(ns com.theplantscape.browser-utils.core
  (:require
    [goog :as goog]
    [goog.object :as gobject]
   [reitit.impl :refer [url-encode]]))

(defn obj->clj
  [obj]
  (if (goog.isObject obj)
    (-> (fn [result key]
          (let [v (gobject/get obj key)]
            (if (= "function" (goog/typeOf v))
              result
              (assoc result key (obj->clj v)))))
        (reduce {} (.getKeys goog/object obj)))
    obj))

(defn download-data-url
  "Given a filename and url in data: format download with the filename."
  [filename data-url]
  (let [anchor-element
        (doto (js/document.createElement "a")
          (.setAttribute "download" filename)
          (.setAttribute "href" data-url))]
    (.appendChild (.-body js/document) anchor-element)
    (.click anchor-element)
    (.removeChild (.-body js/document) anchor-element)))

(defn data-uri-svg
  "Make a data url, and open it to cause a download"
  ([data] (data-uri-svg "image/svg+xml" data))
  ([mimetype data]
   (str "data:" mimetype "," (url-encode data))))

(defn register-gps-data-watch
  "Register a watch which takes a callback to update the gps coordinates"
  [position-fn error-fn]
  (when (.-geolocation js/navigator)
    (.getCurrentPosition (.-geolocation js/navigator) position-fn)
    (.watchPosition
     (.-geolocation js/navigator)
     position-fn
     error-fn
     #js {:enableHighAccuracy true
          :timeout 5000
          :maximumAge 0})))

(defn store-set-item!
  "Set `key' in browser's localStorage to `val`."
  [key val]
  (.setItem (.-localStorage js/window) key val))

#_(defn store-get-item
  "Returns value of `key' from browser's localStorage."
  [key]
  (.getItem (.-localStorage js/window) key))

(defn store-get-item
  "Returns value of `key' from browser's localStorage."
  [key]
  (js->clj (.getItem (.-localStorage js/window) key)))

(defn store-remove-item!
  "Remove the browser's localStorage value for the given `key`"
  [key]
  (.removeItem (.-localStorage js/window) key))

(defn redirect! [loc]
  (set! (.-location js/window) loc))

(defn open-in-new-tab [url]
  (.focus (.open js/window url "_blank")))

(def biometric-auth (atom nil))

(defn to-js-array-buffer [text]
  (js/Uint8Array. (.encode (js/TextEncoder.) text)))

(defn from-js-array-buffer [text]
  (js/btoa text)
  #_(prn (.decode (js/TextDecoder.) text)))

(defn web-auth-store-user [user]
  (prn "store user")
  (prn user)

  (swap! biometric-auth assoc-in [:publicKey :user]
         {:id (to-js-array-buffer (:id user))
          :name (:name user)
          :displayName (:displayName user)}))


(defn web-auth-supported? []
  (some? (.-PublicKeyCredential2 js/window)))

;; https://webauthn.me/debugger

(defn web-auth-create-credentials
  "creates new credentials, either for registering a new account or for associating a new asymmetric key pair credentials with an existing account."
  [public-key-fn]
  ;;(web-auth-store-user user)
  (prn "Web auth credentials create")
  (prn (clj->js @biometric-auth))
  (-> (.-credentials js/navigator)
      (.create (clj->js @biometric-auth))
      (.then (fn new-credentials [^js new-credentials-info]
               (prn "------------")
               (prn (.-getRawId (.-response new-credentials-info)))
               (prn (js/btoa (.-getPublicKey (.-response new-credentials-info))))
               (prn (from-js-array-buffer (.-getPublicKey (.-response new-credentials-info))))
               (public-key-fn (js/btoa (.-getPublicKey (.-response new-credentials-info))))
               ;;(public-key-fn (to-js-array-buffer (.-getPublicKey (.-response new-credentials-info))))
               (prn (.-getAuthenticationData (.-response new-credentials-info)))
               (prn (obj->clj (.-response new-credentials-info)))
               (prn (.getClientExtensionResults new-credentials-info ))))

      (.catch (fn new-create-credentials-error [^js error]
                (prn "error credentials create")
                (prn (.-code error))
                (prn (.-message error))
                ;; Usually incorrect or missing data, especially the rp id must be the hostname
                (prn (.-origin (.-location js/window)))
                (prn "Failed to create webauthn ")
                (prn error)))))

(defn web-auth-get-credentials
  "uses an existing set of credentials to authenticate to a service, either logging a user in or as a form of second-factor authentication"
  []
  (prn "web auth credentials get")
  (prn (clj->js @biometric-auth))
  (-> (.-credentials js/navigator)
      (.get (clj->js @biometric-auth))
      (.then (fn new-credentials [^js new-credentials-info]
               (prn "@@@@@@@@@")
               (prn (.-getClientExtensionResults new-credentials-info))
               (prn new-credentials-info)))
      (.catch (fn new-credentials-error [error]
                (prn (obj->clj error))
                #_(case (obj->clj error)
                  :else (prn "Auth cancelled or timed out!"))
                (prn "error credentials get")
                (prn @biometric-auth)
                (prn (.-code error))
                (prn (obj->clj error))
                (prn error)))))

;https://stackoverflow.blog/2022/11/16/biometric-authentication-for-web-devs/
(comment
  (js/Uint8Array. (js/Array.from (js/btoa "bd4657d4-fec3-4158-8558-1b934f5794e9")))
  (js/Uint8Array. (js/Array.from "bd4657d4-fec3-4158-8558-1b934f5794e9"))
  (js/Uint8Array. (js/btoa "bd4657d4-fec3-4158-8558-1b934f5794e9"))

  (to-js-array-buffer "bd4657d4-fec3-4158-8558-1b934f5794e9")
  (js/btoa "bd4657d4-fec3-4158-8558-1b934f5794e9")

  (js/atob (js/btoa "bd4657d4-fec3-4158-8558-1b934f5794e9"))

  (js/Promise.resolve (web-auth-create-credentials {:name "test name"
                                                    :displayName "test display name"}))
  (web-auth-store-user
   {:name "test name"
    :displayName "test display name"})
  (web-auth-create-credentials
   {:name "test name"
    :displayName "test display name"})

  (web-auth-create-credentials prn)
  (web-auth-get-credentials)

  (prn "abc")
  (js/console.log "test")
  (clj->js @biometric-auth)
  @biometric-auth
  (reset! biometric-auth
          {:publicKey
           {:rp {:id "localhost",
                 :name "localhost"},
            :user {:id (js/Uint8Array. [117 61 252 231 191 241]),
                   :name "krusty@example.com",
                   :displayName "Krusty The Clown"},
            :challenge (js/Uint8Array. [117 61 252 231 191 241]),
            :pubKeyCredParams [{:type "public-key", :alg -7}],
            :authenticatorSelection {}}})

  (reset! biometric-auth
          {:publicKey
           {:rp {:id "localhost",
                 :name "Localhost"},
            :user {:id (js/Uint8Array. (.encode (js/TextEncoder.) "bd4657d4-fec3-4158-8558-1b934f5794e9")),
                   :name "krusty@example.com",
                   :displayName "Krusty The Clown"},
            :challenge (js/Uint8Array. (.encode (js/TextEncoder.) "bd4657d4-fec3-4158-8558-1b934f5794e9")) ,
            :pubKeyCredParams [{:type "public-key", :alg -7}],
            :authenticatorSelection {}}})

;(web-auth-create-credentials biometric-auth)

  (-> (web-auth-create-credentials)
      (.then #(js/console.log %))
      (.catch #(js/console.log %))
      (.finally #(js/console.log "cleanup")))

  (web-auth-get-credentials))
